export const LANGS = ["pt", "es", "en"];

export const dict = {
    pt: {
        nav: { book: "Reservar", talk: "WhatsApp" },
        hero: {
            kicker: "Hostel · Copacabana · Rio de Janeiro",
            lines: ["DURMA BEM.", "ACORDE EM", "COPACABANA."],
            sub: "A 11 minutos a pé da praia, numa rua tranquila de Copacabana. Reserve direto com o hostel: mesmo preço, sem taxa de Booking e check-in flexível.",
            book: "Reservar agora",
            whats: "Falar com a recepção",
            rating: "4.5 no Google · 92 avaliações",
            scroll: "role para descobrir",
        },
        marquee: [
            "A 11 MIN DA PRAIA",
            "RESERVE DIRETO",
            "SEM TAXA DE BOOKING",
            "4.5 NO GOOGLE",
            "METRÔ A 2 MIN",
            "COPACABANA · RIO",
        ],
        beach: {
            chapter: "Capítulo 01",
            label: "A PRAIA",
            title: "11 minutos de caminhada até o mar",
            text: "Acorde, tome o café da manhã e em poucos passos você já está com os pés na areia mais famosa do mundo. Copacabana, Arpoador e Ipanema — tudo a pé.",
            stats: [
                ["11 min", "até a Praia de Copacabana"],
                ["8 min", "até o Arpoador"],
                ["9 min", "até Ipanema"],
            ],
        },
        location: {
            chapter: "Capítulo 02",
            label: "A LOCALIZAÇÃO",
            title: "Tudo do Rio na sua porta",
            text: "Rua tranquila no coração de Copacabana, com supermercado na esquina, dezenas de restaurantes a poucos passos e o metrô Cantagalo a 2 minutos.",
            items: [
                ["Metrô Cantagalo", "2 min a pé"],
                ["Praia de Copacabana", "11 min a pé"],
                ["Arpoador", "8 min"],
                ["Ipanema", "9 min"],
                ["Cristo Redentor", "19 min"],
                ["Pão de Açúcar", "19 min"],
            ],
            address: "R. Emílio Berla, 41 — Copacabana, Rio de Janeiro",
            maps: "Abrir no Google Maps",
        },
        reviews: {
            chapter: "Capítulo 03",
            label: "QUEM FICOU, CONTA",
            title: "Experiência incrível, comprovada",
            score: "4.5",
            of: "de 5 no Google",
            count: "92 avaliações",
            list: [
                { name: "Omar Venegas", text: "A 10 minutos da praia, supermercado na esquina e metrô pertinho. Os anfitriões sempre me fizeram sentir em casa. Recomendo muito." },
                { name: "Jackelin Zedano", text: "Estadia excelente. Todos muito gentis, te fazem sentir em casa. A localização é excelente. Voltarei com certeza." },
                { name: "Adriana C. Leal", text: "Ótima localização e equipe super simpática!" },
                { name: "Natalia Brizuela", text: "Lugar agradável para relaxar, seguro. A equipe sempre à disposição e de confiança." },
                { name: "Wilyen Castillo", text: "Experiência incrível. Me trataram como um filho da família. Muito obrigado!" },
                { name: "Maria Laura A.", text: "Hostel tranquilo, ótimo custo-benefício e um café da manhã completo e delicioso." },
            ],
        },
        ig: {
            chapter: "Extra",
            label: "INSTAGRAM",
            title: "@matianelluhostel",
            text: "O dia a dia do hostel, direto do nosso feed. Siga e acompanhe Copacabana com a gente.",
            cta: "Seguir no Instagram",
        },
        direct: {
            chapter: "Capítulo 04",
            label: "RESERVE DIRETO",
            title: "Mesmo preço. Mais vantagens.",
            text: "Ao reservar direto com o Matianellu você evita taxas de plataforma e fala direto com quem vai te receber no Rio.",
            benefits: [
                "Sem taxa de Booking ou outras plataformas",
                "Melhor preço garantido",
                "Check-in flexível — avise pelo WhatsApp",
                "Atendimento direto em português, espanhol e inglês",
            ],
            book: "Reservar no site oficial",
            whats: "Consultar no WhatsApp",
            note: "Reserva segura pelo nosso motor oficial",
        },
        footer: {
            tag: "Seu hostel em Copacabana",
            contact: "Contato",
            follow: "Siga-nos",
            rights: "© 2026 Matianellu Hostel · Rio de Janeiro",
        },
        waMsg: "Olá! Vim pelo site e gostaria de consultar disponibilidade no Matianellu Hostel.",
    },
    es: {
        nav: { book: "Reservar", talk: "WhatsApp" },
        hero: {
            kicker: "Hostel · Copacabana · Río de Janeiro",
            lines: ["DUERME BIEN.", "DESPIERTA EN", "COPACABANA."],
            sub: "A 11 minutos a pie de la playa, en una calle tranquila de Copacabana. Reserva directo con el hostel: mismo precio, sin comisión de Booking y check-in flexible.",
            book: "Reservar ahora",
            whats: "Hablar con recepción",
            rating: "4.5 en Google · 92 reseñas",
            scroll: "desliza para descubrir",
        },
        marquee: [
            "A 11 MIN DE LA PLAYA",
            "RESERVA DIRECTA",
            "SIN COMISIÓN DE BOOKING",
            "4.5 EN GOOGLE",
            "METRO A 2 MIN",
            "COPACABANA · RÍO",
        ],
        beach: {
            chapter: "Capítulo 01",
            label: "LA PLAYA",
            title: "11 minutos caminando hasta el mar",
            text: "Despierta, desayuna y en pocos pasos ya tienes los pies en la arena más famosa del mundo. Copacabana, Arpoador e Ipanema — todo a pie.",
            stats: [
                ["11 min", "hasta la Playa de Copacabana"],
                ["8 min", "hasta Arpoador"],
                ["9 min", "hasta Ipanema"],
            ],
        },
        location: {
            chapter: "Capítulo 02",
            label: "LA UBICACIÓN",
            title: "Todo Río a tu puerta",
            text: "Calle tranquila en el corazón de Copacabana, con supermercado en la esquina, decenas de restaurantes a pocos pasos y el metro Cantagalo a 2 minutos.",
            items: [
                ["Metro Cantagalo", "2 min a pie"],
                ["Playa de Copacabana", "11 min a pie"],
                ["Arpoador", "8 min"],
                ["Ipanema", "9 min"],
                ["Cristo Redentor", "19 min"],
                ["Pan de Azúcar", "19 min"],
            ],
            address: "R. Emílio Berla, 41 — Copacabana, Río de Janeiro",
            maps: "Abrir en Google Maps",
        },
        reviews: {
            chapter: "Capítulo 03",
            label: "QUIEN SE QUEDÓ, CUENTA",
            title: "Experiencia increíble, comprobada",
            score: "4.5",
            of: "de 5 en Google",
            count: "92 reseñas",
            list: [
                { name: "Omar Venegas", text: "A 10 minutos de la playa, supermercado a media cuadra y metro cerca. Los anfitriones siempre me hicieron sentir en casa. Lo recomiendo ampliamente." },
                { name: "Jackelin Zedano", text: "Excelente estancia. Todos muy amables, te hacen sentir como en casa. La ubicación es excelente. Sin duda volveré." },
                { name: "Adriana C. Leal", text: "¡Buena ubicación y staff súper friendly!" },
                { name: "Natalia Brizuela", text: "Lugar agradable para relajarse, seguro. El equipo siempre a disposición y confiable." },
                { name: "Wilyen Castillo", text: "Experiencia increíble. Me trataron como un hijo de la familia. ¡Muito obrigado!" },
                { name: "Maria Laura A.", text: "Hostel tranquilo, buena relación precio-calidad y un desayuno rico y completo." },
            ],
        },
        ig: {
            chapter: "Extra",
            label: "INSTAGRAM",
            title: "@matianelluhostel",
            text: "El día a día del hostel, directo desde nuestro feed. Seguinos y vivi Copacabana con nosotros.",
            cta: "Seguir en Instagram",
        },
        direct: {
            chapter: "Capítulo 04",
            label: "RESERVA DIRECTA",
            title: "Mismo precio. Más ventajas.",
            text: "Al reservar directo con el Matianellu evitas comisiones de plataforma y hablas directo con quien te recibirá en Río.",
            benefits: [
                "Sin comisión de Booking u otras plataformas",
                "Mejor precio garantizado",
                "Check-in flexible — avisa por WhatsApp",
                "Atención directa en portugués, español e inglés",
            ],
            book: "Reservar en el sitio oficial",
            whats: "Consultar por WhatsApp",
            note: "Reserva segura por nuestro motor oficial",
        },
        footer: {
            tag: "Tu hostel en Copacabana",
            contact: "Contacto",
            follow: "Síguenos",
            rights: "© 2026 Matianellu Hostel · Río de Janeiro",
        },
        waMsg: "¡Hola! Vengo del sitio web y quisiera consultar disponibilidad en Matianellu Hostel.",
    },
    en: {
        nav: { book: "Book now", talk: "WhatsApp" },
        hero: {
            kicker: "Hostel · Copacabana · Rio de Janeiro",
            lines: ["SLEEP WELL.", "WAKE UP IN", "COPACABANA."],
            sub: "An 11-minute walk from the beach, on a quiet Copacabana street. Book direct with the hostel: same price, no Booking fees and flexible check-in.",
            book: "Book now",
            whats: "Chat with reception",
            rating: "4.5 on Google · 92 reviews",
            scroll: "scroll to discover",
        },
        marquee: [
            "11 MIN TO THE BEACH",
            "BOOK DIRECT",
            "NO BOOKING FEES",
            "4.5 ON GOOGLE",
            "METRO 2 MIN AWAY",
            "COPACABANA · RIO",
        ],
        beach: {
            chapter: "Chapter 01",
            label: "THE BEACH",
            title: "An 11-minute walk to the ocean",
            text: "Wake up, have breakfast and within a few steps your feet are on the world's most famous sand. Copacabana, Arpoador and Ipanema — all on foot.",
            stats: [
                ["11 min", "to Copacabana Beach"],
                ["8 min", "to Arpoador"],
                ["9 min", "to Ipanema"],
            ],
        },
        location: {
            chapter: "Chapter 02",
            label: "THE LOCATION",
            title: "All of Rio at your doorstep",
            text: "A quiet street in the heart of Copacabana, with a supermarket on the corner, dozens of restaurants steps away and Cantagalo metro station 2 minutes away.",
            items: [
                ["Cantagalo Metro", "2 min walk"],
                ["Copacabana Beach", "11 min walk"],
                ["Arpoador", "8 min"],
                ["Ipanema", "9 min"],
                ["Christ the Redeemer", "19 min"],
                ["Sugarloaf Mountain", "19 min"],
            ],
            address: "R. Emílio Berla, 41 — Copacabana, Rio de Janeiro",
            maps: "Open in Google Maps",
        },
        reviews: {
            chapter: "Chapter 03",
            label: "GUESTS TELL IT BEST",
            title: "An incredible experience, proven",
            score: "4.5",
            of: "out of 5 on Google",
            count: "92 reviews",
            list: [
                { name: "Omar Venegas", text: "10 minutes from the beach, supermarket around the corner and the metro close by. The hosts always made me feel at home. Highly recommended." },
                { name: "Jackelin Zedano", text: "Excellent stay. Everyone was so kind, they make you feel at home. The location is excellent. I will definitely come back." },
                { name: "Adriana C. Leal", text: "Great location and a super friendly staff!" },
                { name: "Natalia Brizuela", text: "A pleasant, safe place to relax. The team is always available and trustworthy." },
                { name: "Wilyen Castillo", text: "An incredible experience. They treated me like a son of the family. Thank you so much!" },
                { name: "Maria Laura A.", text: "Quiet hostel, great value for money and a rich, complete breakfast." },
            ],
        },
        ig: {
            chapter: "Extra",
            label: "INSTAGRAM",
            title: "@matianelluhostel",
            text: "Hostel life, straight from our feed. Follow along and experience Copacabana with us.",
            cta: "Follow on Instagram",
        },
        direct: {
            chapter: "Chapter 04",
            label: "BOOK DIRECT",
            title: "Same price. More perks.",
            text: "When you book direct with Matianellu you skip platform fees and talk straight to the people who will welcome you in Rio.",
            benefits: [
                "No Booking or platform fees",
                "Best price guaranteed",
                "Flexible check-in — just message us on WhatsApp",
                "Direct service in Portuguese, Spanish and English",
            ],
            book: "Book on the official site",
            whats: "Ask on WhatsApp",
            note: "Secure booking through our official engine",
        },
        footer: {
            tag: "Your hostel in Copacabana",
            contact: "Contact",
            follow: "Follow us",
            rights: "© 2026 Matianellu Hostel · Rio de Janeiro",
        },
        waMsg: "Hi! I came from the website and would like to check availability at Matianellu Hostel.",
    },
};
